import { render } from "./top-selling-item-chart.vue?vue&type=template&id=68748497"
import script from "./top-selling-item-chart.vue?vue&type=script&lang=js"
export * from "./top-selling-item-chart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__